export default __webpack_public_path__ + "static/media/polimorphic_shape_green.1ced261a.svg";